import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useField } from '@unform/core';
import { Autocomplete, TextField } from '@mui/material';
import i18n from '../../../services/i18n';

function InputSelectAutoComplete({
                                   name,
                                   label,
                                   options = [],
                                   placeholder = i18n.t('placeholder_select'),
                                   InputProps = {},
                                   defaultValue,
                                   ...props
                                 }) {
  const inputRef = useRef(null);
  const { fieldName, registerField, error } = useField(name);

  const [selected, setSelected] = useState(() => {
    return options.find(option => option.key === defaultValue) || null;
  });

  // Atualiza selected se defaultValue mudar (ex: após fetch)
  useEffect(() => {
    const found = options.find(option => option.key === defaultValue) || null;
    setSelected(found);
    if (inputRef.current) {
      inputRef.current.value = found?.key || '';
    }
  }, [defaultValue, options]);

  // Unform integration
  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      getValue: () => inputRef.current?.value || '',
      setValue: (_, value) => {
        const found = options.find(option => option.key === value);
        if (found) setSelected(found);
      },
      clearValue: () => {
        setSelected(null);
      },
    });
  }, [fieldName, registerField, options]);

  // Atualiza valor do input hidden
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.value = selected?.key || '';
    }
  }, [selected]);

  return (
    <>
      <input type="hidden" ref={inputRef} name={name} />
      <Autocomplete
        style={{ width: '100%' }}
        options={options}
        getOptionLabel={(option) => option?.value || ''}
        value={selected}
        onChange={(_, newValue) => setSelected(newValue)}
        isOptionEqualToValue={(option, value) => option.key === value.key}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder={placeholder}
            error={!!error}
            helperText={error}
            fullWidth
            InputProps={{
              ...params.InputProps,
              ...InputProps, // <-- Suporte a adornos, etc.
            }}
          />
        )}
        {...props}
      />
    </>
  );
}

InputSelectAutoComplete.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  InputProps: PropTypes.object,
};

export default InputSelectAutoComplete;
